export default __webpack_public_path__ + "static/media/alert-tooltip-warning.0f5711a8.svg";